import TimelogsDashboardList from './TimelogsDashboardList';

export default TimelogsDashboardList;
